module.exports = __webpack_public_path__ + "static/media/trophy.3a60f68a.svg";